import styled from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;
const { SIDEBAR_TRANSITION, SIDEBAR_WIDTH } = constants.sidebar;

// the position has to be fixed due to a scroll behavior in chrome/firefox
// and hight values of the webview will hide absolute values at the
//  bottom of the page until the user holds and scrolls up on a button
export const FooterContainer = styled.div`
  bottom: 0;
  height: 45px;
  justify-content: center;
  padding: 0 15px 15px;
  position: fixed;
  transition: ${SIDEBAR_TRANSITION};
  width: ${({ isSidebarOpen }) =>
    isSidebarOpen ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%'};
  display: ${({ isDisplayed }) => (isDisplayed ? 'flex' : 'none')};
`;

export const LogoContainer = styled.div`
  position: absolute;
  left: 0;
  margin-left: 15px;
  display: ${({ isDisplayed }) => (isDisplayed ? 'flex' : 'none')};
`;

export const LogoHouseText = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  width: 73px;
  height: 20px;
  background-image: url(${require('src/assets/images/logo_full_28.png')});
`;

export const JobAddress = styled.div`
  ${({ theme }) => theme.mixins.font('book', 14)}
  line-height: 39px;
  color: ${({ theme }) => theme.colors.grayButtonNormalText};
`;
